import React, { useEffect, useState } from "react";
import CssBaseline from "@material-ui/core/CssBaseline";
import { makeStyles } from "@material-ui/core/styles";
import Typewriter from "typewriter-effect";
import Container from "@material-ui/core/Container";
import { useSelector } from "react-redux";
import { checkGameStatus } from "../../service/logic";
import { store } from "../../redux/store";
import { GAME_STAGE } from "../../utils/constant";
import { history } from "../../index";
import { setGameStatus } from "../../redux/dispatchers";
import {
  BackgroundComponent,
  DoctorComponent,
  RightBottomButton,
} from "../common";
import { fontSize } from "../../styles";

const useStyles = makeStyles((theme) => ({
  canvas: {
    paddingTop: "10%",
  },
  card: {
    [theme.breakpoints.up("lg")]: {
      width: 650,
      height: 400,
      padding: theme.spacing(5, 3, 3, 3),
    },
    [theme.breakpoints.down("md")]: {
      width: 400,
      height: 400,
      padding: theme.spacing(5, 3, 0, 3),
    },
    [theme.breakpoints.down("sm")]: {
      width: 250,
      height: 400,
      padding: theme.spacing(5, 3, 0, 3),
    },
    border: "1px solid black",
    backgroundColor: "white",
    paddingBottom: theme.spacing(0.2),
    marginLeft: "10%",
  },
  kasediv: {
    display: "flex",
    flex: 1,
    justifyContent: "flex-start",
    [theme.breakpoints.up("md")]: {
      fontSize: fontSize.h3,
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: fontSize.h4,
    },
  },
  button: {
    width: 200,
    height: 50,
    color: "#FFFFFF",
    background: "#4CC87D",
    textTransform: "none",
    position: "absolute",
    right: 20,
    bottom: 20,
  },
}));

function Presentation() {
  const classes = useStyles();
  const [isComplete, setIsComplete] = useState(false);
  const { status, presentationFlag } = useSelector((state) => state.gameStates);

  useEffect(() => {
    // check if user is allowed to enter presentation page
    if (!checkGameStatus(GAME_STAGE.PRESENTATION)) {
      if (presentationFlag) return;
      // if not allowed, navigate to case list page
      if (status < 1 || status > 14) history.push("/cases");
      else history.push("/game");
    }
  }, [status, presentationFlag]);

  const navigateGame = () => {
    if (!presentationFlag) setGameStatus(GAME_STAGE.HISTORY_TAKING);
    history.push("/game");
  };

  return (
    <React.Fragment>
      <CssBaseline />
      <BackgroundComponent transparent />
      <DoctorComponent />
      <div className={classes.canvas}>
        <div className={`${classes.card}`}>
          {!isComplete ? (
            <Container className={classes.kasediv}>
              {!!store.getState().gameStates.case ? (
                <Typewriter
                  onInit={(typewriter) => {
                    typewriter
                      .changeDelay(10)
                      .typeString(store.getState().gameStates.case.presentation)
                      .callFunction(() => {
                        setIsComplete(true);
                      })
                      .start();
                  }}
                />
              ) : (
                <></>
              )}
            </Container>
          ) : (
            <Container className={classes.kasediv}>
              {!!store.getState().gameStates.case ? (
                <div>{store.getState().gameStates.case.presentation}</div>
              ) : (
                <></>
              )}
            </Container>
          )}
        </div>
      </div>
      {isComplete ? (
        <RightBottomButton navigate={navigateGame} label="Continue" />
      ) : (
        <div onClick={() => setIsComplete(true)}>
          <RightBottomButton navigate={null} label="Fast Forward" />
        </div>
      )}
    </React.Fragment>
  );
}

export default Presentation;
